import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ListComponent from '../../../../core/infraestructure/ListComponent';
import HighSchoolViewModel from '../../../../core/features/setting/viewmodels/HighSchoolViewModel';

export default {
  extends: ListComponent,
  data() {
    return {
      modulePermissions: 'Settings-HighSchools',
      item: null,
      searchName: null,
      searchCode: null,
      viewModel: null,
      parentFilter: '',
      parents: [],
      modalImport: {
        isVisible: false,
        isLoading: false,
        title: 'IMPORTAR PREPARATORIAS',
        onUploadImport: 'onUploadImportHighSchool',
        onCancelImport: 'onCancelImportHighSchool',
      },
      filterOptions: {
        status: ''
      },
    };
  },
  mounted() {
    EventBus.$on('onSubmitedHighSchool', this.onSearch);
    EventBus.$on('onUploadImportHighSchool', this.onUploadImport);
    EventBus.$on('onCancelImportHighSchool', this.onCancelImport);
  },
  beforeDestroy() {
    EventBus.$off('onSubmitedHighSchool', this.onSearch);
    EventBus.$off('onUploadImportHighSchool', this.onUploadImport);
    EventBus.$off('onCancelImportHighSchool', this.onCancelImport);
  },
  created() {
    this.viewModel = new HighSchoolViewModel(this);
    this.onActive();
  },
  methods: {
    onActive() {
      this.onSearch();
    },
    onAllFilterChange(data, field) {
      this.onFilterChange(data, field);
    },
    onSearchCourseCategory(data) {
      if (data) {
        this.viewModel.findCourseCategories(`Name=${data}`)
    } else {
        this.parents = []
    }
    },
    onSearchCourseCategoriesResponse(response) {
      this.parents = response;
    },
    onFocusCourseCategory() {
      this.$forceUpdate()
    },
    onShowImport() {
      this.viewModel.showModal(this.modalImport, true);
    },
    onUploadImport(file){
      this.viewModel.showModalLoading(this.modalImport, true);
      this.viewModel.import(file);
    },
    onCancelImport(){
      this.viewModel.showModal(this.modalImport, false);
    },
    onExportToExcel() {
      this.viewModel.exportToExcel();
    },
    onCanCreate() {
      return this.canCreate(this.modulePermissions)
    },
    onCanRead() {
      return this.canRead(this.modulePermissions)
    },
    onCanUpdate() {
      return this.canUpdate(this.modulePermissions)
    },
    onCanDelete() {
      return this.canDelete(this.modulePermissions)
    },
  },
  computed: {}
}